export const CHAT_HISTORY_URLS = {
  chatHistoryPage: '',
} as const;
